/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';

/**
 * Shared channel state used to coordinate modules that depend on the selectedStoreId (channelid) cookie
 * and on the tableId cookie. The header view resolves the suite/store mapping asynchronously, so modules
 * that read either cookie on mount must wait for isReady before firing their calls.
 *
 * tableId is the hospitality id returned by LAC_SuiteToValidateAdmin, never the external suite id that
 * arrives in the suiteId query string.
 */
export interface IChannelState {
    channelId: number;
    tableId: string;
    isReady: boolean;
}

export class ChannelStateInput implements IActionInput {
    public getCacheKey = () => `ChannelState`;
    public getCacheObjectType = () => 'ChannelState';
    public dataCacheType = (): CacheType => 'request';
}

async function channelStateAction(input: ChannelStateInput, ctx: IActionContext): Promise<IChannelState> {
    return { channelId: 0, tableId: '', isReady: false };
}

const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new ChannelStateInput();
};

export default createObservableDataAction<IChannelState>({
    action: <IAction<IChannelState>>channelStateAction,
    input: createInput
});
